// Plan-a-Date countdown: ticks once a second while a planned date exists (verbatim from App.jsx).
import { useState, useEffect } from 'react';

export function useCountdown(plannedDate) {
    const [dateCountdown, setDateCountdown] = useState(null);

    // Plan a Date countdown timer
    useEffect(() => {
        if (!plannedDate || !plannedDate.dateTime) {
            setDateCountdown(null);
            return;
        }
        const updateCountdown = () => {
            const now = new Date().getTime();
            const target = new Date(plannedDate.dateTime).getTime();
            const diff = target - now;
            if (diff <= 0) {
                setDateCountdown({ days: 0, hours: 0, minutes: 0, seconds: 0, passed: true });
                return;
            }
            setDateCountdown({
                days: Math.floor(diff / (1000 * 60 * 60 * 24)),
                hours: Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
                seconds: Math.floor((diff % (1000 * 60)) / 1000),
                passed: false
            });
        };
        updateCountdown();
        const interval = setInterval(updateCountdown, 1000);
        return () => clearInterval(interval);
    }, [plannedDate]);

    return dateCountdown;
}
